/* PIECE & CO - Editorial layer behaviours */
(function () {
  'use strict';

  function initAlpha(root) {
    if (root.dataset.pcAlphaReady === 'true') return;
    root.dataset.pcAlphaReady = 'true';

    var buttons = root.querySelectorAll('.pc-alpha button');
    var items = root.querySelectorAll('[data-pc-letter]');
    if (!buttons.length || !items.length) return;

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var letter = btn.getAttribute('data-letter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        items.forEach(function (item) {
          item.hidden = letter !== 'all' && item.getAttribute('data-pc-letter') !== letter;
        });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pc-brands]').forEach(initAlpha);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();